import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "@/utils/ScrollToTop";
import { CookieConsent, CookieConsentEs } from "@/components/CookieConsent";
import { PopupManagerProvider, KickPromoPopup } from "@/components/Shared";
import {
  useAnalytics,
  useScrollDepth,
  useTimeOnPage,
  useLinkTracking,
} from "@/hooks";

const PageLayout: React.FC = () => {
  const location = useLocation();
  const isSpanish = location.pathname.startsWith("/es");
  const language = isSpanish ? "es" : "en";

  useAnalytics({ language });
  useScrollDepth();
  useTimeOnPage();
  // Delegated tracking for every link on the page — see useLinkTracking for why this
  // is one listener instead of handlers on ~80 individual anchors.
  useLinkTracking(language);

  return (
    <PopupManagerProvider>
      <ScrollToTop />
      {/* Skip-to-content — visible only on keyboard focus. WCAG 2.4.1 Bypass Blocks. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-metro-orange-500 focus:text-dark-950 focus:font-semibold focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-metro-orange-300 focus:ring-offset-2 focus:ring-offset-dark-950"
      >
        {language === "es" ? "Saltar al contenido" : "Skip to content"}
      </a>
      <div className="flex flex-col min-h-screen">
        <Header language={language} />
        <main id="main-content" tabIndex={-1} className="flex-grow focus:outline-none">
          <Outlet />
        </main>
        <Footer language={language} />
      </div>
      {/* Cookie Consent Banner */}
      {isSpanish ? <CookieConsentEs /> : <CookieConsent />}
      {/* Timed Kick promotion popup — appears after 3.5 min, auto-hides after 20s */}
      <KickPromoPopup language={language} />
    </PopupManagerProvider>
  );
};

export default PageLayout;
